"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Logger_1 = require("../utils/Logger");

exports.LogLevel = Logger_1.LogLevel;

var Config = function () {
  function Config() {}

  return Config;
}();

exports.Config = Config;
exports.default = Config;